import { EmployeeBillingInputDto } from "../../dtos/employeeBilling/EmployeeBillingInputDto";
import { post } from "../../utills/BaseService";

export async function getAllProjectBillingData(dispatch: any, input: EmployeeBillingInputDto): Promise<any> {
   return await post(dispatch, '/projectBilling/getAllProjectBillingData', input);
};
